(ns ycweb.app.website.myaccount.myaccount
  (:require
   [rum.core :as rum]
   [ycweb.app.website.myaccount.addresses.addresses]
   [ycweb.app.website.myaccount.addresses.list]
   [ycweb.app.website.myaccount.aftersales.cases]
   [ycweb.app.website.myaccount.aftersales.clientorders]
   [ycweb.app.website.myaccount.aftersales.complete]
   [ycweb.app.website.myaccount.aftersales.confirm]
   [ycweb.app.website.myaccount.aftersales.create]
   [ycweb.app.website.myaccount.aftersales.view]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.myaccount.cookingschool.cookingschool]
   [ycweb.app.website.myaccount.newsletters.newsletters]
   [ycweb.app.website.myaccount.orders.invoice]
   [ycweb.app.website.myaccount.orders.list :as orderslist]
   [ycweb.app.website.myaccount.orders.view]
   [ycweb.app.website.myaccount.profile.profile]
   [ycweb.app.website.myaccount.registries.registries]
   [ycweb.app.website.myaccount.reviews.add]
   [ycweb.app.website.myaccount.reviews.edit]
   [ycweb.app.website.myaccount.reviews.list]
   [ycweb.app.website.myaccount.reviews.thankyou]
   [ycweb.app.website.myaccount.reviews.view]
   [ycweb.app.website.myaccount.wishlist.wishlist]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

;; Footer menu
(rum/defc footer-menu [app-atom]
  [:div.quick-links-wrapper.yc-section.yc-section--standard
   [:div.flex-grid-group
    [:div.flex-grid-block.flex-grid-block--ml-1-3
     [:nav.flex-grid-content
      {:class (u/bem :card [:is-flex-column :no-hover] :text-card [:medium])}
      (headings/heading "Manage orders" {:type :h3 :size :tiny :center true})
      [:ul.yc-list.u-no-list-bullets.u-text-center
       [:li [:a.text-link {:href "/myaccount.htm?action=track"} "View and track orders"]]
       [:li [:a.text-link {:href "/myaccount.htm?action=track"} "Find and print invoices"]]
       [:li [:a.text-link {:href "/myaccount.htm?action=aftersales"} "Returns and Repairs"]]]]]
    [:div.flex-grid-block.flex-grid-block--ml-1-3
     [:nav.flex-grid-content
      {:class (u/bem :card [:is-flex-column :no-hover] :text-card [:medium])}
      (headings/heading "Account Settings" {:type :h3 :size :tiny :center true})
      [:ul.yc-list.u-no-list-bullets.u-text-center
       [:li [:a.text-link {:href "/myaccount.htm?action=accountsettings"} "Change Account Settings"]]
       [:li [:a.text-link {:href "/myaccount.htm?action=addressbook"} "Manage Addresses"]]
       [:li [:a.text-link {:href "/newsletter.htm?action=preferences"} "Newsletter Settings"]]]]]
    [:div.flex-grid-block.flex-grid-block--ml-1-3
     [:nav.flex-grid-content
      {:class (u/bem :card [:is-flex-column :no-hover] :text-card [:medium])}
      (headings/heading "Help Center" {:type :h3 :size :tiny :center true})
      [:ul.yc-list.u-no-list-bullets.u-text-center
       [:li [:a.text-link {:href "/help.htm?action=article&amp;id=60&amp;name=Bank-Details-for-Payments"} "EFT Payment Details"]]
       [:li [:a.text-link {:href "/help.htm?action=article&amp;id=45&amp;name=Cancelling-My-Order"} "How to cancel an order"]]
       [:li [:a.text-link {:href "/help.htm?action=faqs"} "Frequently Asked Questions"]]
       [:li [:a.text-link {:href "/help.htm"} "Contact Customer Service"]]]]]]])

(rum/defc myaccount-dashboard [app-atom]
  [:div
   [:div.dashboard
    (orderslist/orders app-atom)
    [:div.dashboard-footer
     (buttons/button-web "View all past orders"
       (merge
         (urlstate/href-props app-atom "myaccount" "orders")
         {:style :secondary
          :size :small}))]]

   [:div.yc-section.yc-section--standard
    [:div.flex-grid-group
     [:div.flex-grid-block.flex-grid-block--ml-1-3
      [:nav.card.card--is-flex-column.card--no-hover.text-card.text-card--medium.flex-grid-content
       [:h3.yc-heading.yc-heading--tiny.yc-heading--center "Manage Orders"]
       [:ul.yc-list.yc-list--flush.u-no-list-bullets.u-text-center
        [:li
         [:a.text-link
          (urlstate/href-props app-atom "myaccount" "orders")
          "View and track orders"]]
        [:li
         [:a.text-link
          (urlstate/href-props app-atom "myaccount" "orders")
          "Find and print invoices"]]
        [:li
         [:a.text-link
          (urlstate/href-props app-atom "myaccount" "aftersales")
          "Returns and Repairs"]]]]]
     [:div.flex-grid-block.flex-grid-block--ml-1-3
      [:nav.card.card--is-flex-column.card--no-hover.text-card.text-card--medium.flex-grid-content
       [:h3.yc-heading.yc-heading--tiny.yc-heading--center "Account Settings"]
       [:ul.yc-list.yc-list--flush.u-no-list-bullets.u-text-center
        [:li
         [:a.text-link
          (urlstate/href-props app-atom "myaccount" "accountsettings")
          "Change Account Settings"]]
        [:li
         [:a.text-link
          (urlstate/href-props app-atom "myaccount" "addressbook")
          "Manage Addresses"]]
        [:li
         [:a.text-link
          (urlstate/href-props app-atom "myaccount" "newsletters")
          "Newsletter Settings"]]]]]
     [:div.flex-grid-block.flex-grid-block--ml-1-3
      [:nav.card.card--is-flex-column.card--no-hover.text-card.text-card--medium.flex-grid-content
       [:h3.yc-heading.yc-heading--tiny.yc-heading--center "Help Center"]
       [:ul.yc-list.yc-list--flush.u-no-list-bullets.u-text-center
        [:li
         [:a.text-link {:href "/help.htm?action=article&id=60&name=Bank-Details-for-Payments"} "EFT Payment Details"]]
        [:li
         [:a.text-link {:href "/help.htm?action=article&id=45&name=Cancelling-My-Order"} "How to cancel an order"]]
        [:li
         [:a.text-link {:href "/help.htm?action=faqs"} "Frequently Asked Questions"]]
        [:li
         [:a.text-link {:href "/help.htm"} "Contact Customer Support"]]]]]]]])

(defmethod flow/render-screen :web.myaccount [app-atom _]
  (awm.common/screen-wrapper app-atom
    (myaccount-dashboard app-atom)))

;; Order view
(defmethod t/transition-open :web.myaccount [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/orderslist)
  (comms/ajax-get :web/myaccount {}))

(defmethod comms/receive :web/myaccount [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/orderslist)
  (swap! (cmn/action-cursor app-atom) assoc :order-history (take 5 (:order-history e))))


;; Components
(rum/defc component < rum/reactive [app-atom]
  (let [state (rum/react (cmn/action-cursor app-atom))]
    (list
      [:h1 "Components"]
      (pr-str (:reviews state))

      (footer-menu app-atom))))

(defmethod flow/render-screen :web.myaccount/components [app-atom _]
  (awm.common/screen-wrapper app-atom
    (component app-atom)))

;; TODO
;; CLEANUP
;; - input shapes
;; - output shapes
;; - search js- classes, remove and check that we have all functionality
;; - check console errors on all pages
;; - check clj log for errors on all pages
;; - add keys to list items (like on table rows) - Chris has done this on orders and reviews


;; ISSUES
;; - reviews add isn't updating image for different products
;; - reviews - add a review from product pages takes you to old my account on this link: https://yourname.dev.yuppiechef.com/reviews.htm?contentid=35185
;; - order listing page - collection "await notification" link isn't working (it's a magnific popup)
;; - Sentry integration
;; - addresses - deleting shows empty addresses page on live
;; - wishlist - notify me smaller, and aligned
;; - wishlist - buttons for cart?
;; - newsletters - None, can we make this a toggle, and disable the rest when not toggled
;; - dashboard landing - button to the right

;; PAGING
;; - adding the page numbers to URL for pagination
;; - paging needs loader overlay on next page click?
;; - add paging to all pages where needed


;; ARCHITECTURE
;; - We shouldn’t show the connection open toaster
;;     or version out of date toasts / we'll need to work on the 'please refresh, new version' message
;; - customer facing error messaging (generic with override if user message specified) - Whoops! Something went wrong. Please try again in a few minutes.
;; - possible comms error toast - what does it mean, what do we need to do with it?
;; - no auth should redirect to login (with redirect url?)
;;     currently users can keep clicking around in the app, even on no auth error
;; - permanent redirect functionality (id vs uuid) htaccess vibey


;; MISSING FUNCTIONALITY


;; JOZEL - Todo's Doing
;; - check pages for other todo's

;; DONE
;; - profile pic not showing
;; - wishlist - notify me
;; - adding an address - Default country needs to be South Africa
;; - Dashboard landing page - Show registries and helpful links like it does currently
;; - datepicker on returns and repairs
;; - make sure loading states are added to empty states as well (or in a containing div that covers empty and non-empty states)
;; - make sure we have empty states everywhere that's needed
;; - 404 page for unsupported screen?
;; - make sure all t/transition-open have loader overlay where needed - (toaster/open-overlay app-atom :web.myaccount/reviewslist)
;; - double check url's match what we have on live
;; - wishlist images and product links are missing or don't work
;; - wishlist doesn't seem 100% - compare live to dev
;; - style image uploads on returns final step
;; - returns file uploader - try and use Dope File Uploader and Jon needs to work on adjusting the UI to have a little X on the image that you press to delete.
;; - paging - scroll to top of list when pressing on a different page
;; - paging - cursor isn't pointer on anchor tags
;; - paging - aftersales list starts at zero?